
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class AccountOverrideDialog extends SiteEntityDialog<AccountOverrideRow, any> {
        protected getFormKey() { return AccountOverrideForm.formKey; }
        protected getIdProperty() { return AccountOverrideRow.idProperty; }
        protected getLocalTextPrefix() { return AccountOverrideRow.localTextPrefix; }
        protected getNameProperty() { return AccountOverrideRow.nameProperty; }
        protected getService() { return AccountOverrideService.baseUrl; }

        protected form = new AccountOverrideForm(this.idPrefix);

    }
}